import React from 'react';

const OddsRow = ({ row, selectedMarkets, onHandleOddsClick }) => (
  <div key={row[0].id} className="odds-type__row">
    {row.map((market) => (
      <div key={market.id} className="odds-type__select">
        <label className="checkbox">
          <input
            id={`selected-market-${market.id}`}
            type="checkbox"
            onChange={onHandleOddsClick.bind(null, market.id)}
            checked={selectedMarkets.includes(market.id)}
          />
          <div className="checkbox__icon m-r-20" />
          <span className="checkbox__label">{market.name}</span>
        </label>
      </div>
    ))}
  </div>
);

export default OddsRow;